import { useEffect, useMemo, useState } from "react";
import { isMobile } from "@rio-cloud/rio-uikit/utils/deviceUtils";
import DatePicker from "@rio-cloud/rio-uikit/components/datepicker/DatePicker";
import Select from "@rio-cloud/rio-uikit/components/selects/Select";
import { Moment } from "moment";

import { IChildForm } from "../../../";
import CopyButton from "./CopyButton";

import SearchAutocomplete from "../../../../../components/form/searchAutocomplete";

import { AssetModel } from "../../../../../models/asset";

import ErrorDialog from "../../../../dialogs/ErrorDialog";
import LoadingDialog from "../../../../dialogs/LoadingDialog";

import { useVehicleForm } from "../hooks/useVehicleForm";
import { useLocation } from "react-router";
import { formatOccurrenceTypeLabel } from "../../../../../enums/occurrenceType";
import { useIntl } from "react-intl";

const VehicleChildForm = (props: IChildForm) => {
  const intl = useIntl();

  const { 
    showLoadingDialog, 
    loadingMessage, 
    showErrorDialog, 
    errorMessage,
    volkstotalData,
    assetModels,
    protocolNumber,
    volksEssentialsPlan,

    setShowErrorDialog, 
    validateChassis,
    formatProtocolNumber,
  } = useVehicleForm(props);

  const location = useLocation();
  const isDealer = !!location.pathname.startsWith('/dealership');

  useEffect(() => {
    if (!props.occurrence?.vehicleModelCode || props.occurrence?.vehicleModel) return;
    const modelFromCode = assetModels.find((m) => m.modelCode === props.occurrence?.vehicleModelCode);
    if (modelFromCode?.modelId) {
      props.setOccurrenceValue("vehicleModel", modelFromCode.modelId);
      props.setOccurrenceValue("model", modelFromCode.description);
    }
  }, [props.occurrence?.vehicleModelCode, assetModels]);

  return (
    <>
      <div
        className={`flex justify-between w-full gap-6 ${isMobile() ? "flex-wrap" : ""
          }`}
      >
        {/* {!props.hiddenFields.includes("protocolNumber") && (
          <div className={`form-group form-group-lg w-full `}>
            <label htmlFor="protocolNumber" className="truncate">
              Número da ocorrência
            </label>
            <div className={`flex gap-4 ${isMobile() ? "flex-wrap" : "items-center"}`}>
              <div className="relative flex-1">
                <input
                  id="protocolNumber"
                  type="text"
                  className="form-control pr-10"
                  placeholder="OCOR-XXXXXX-XXXXXX"
                  disabled={props.disabledAllFields}
                  value={protocolNumber}
                  onChange={(e) => formatProtocolNumber(e.target.value)}
                />
              </div>
            </div>
          </div>
        )} */}

        {props.hiddenFields.includes("occurrenceType") ||
          props.persona === "MANAGER" ? null : (
          <div
            className={`form-group form-group-lg w-full ${props.hasError &&
              props.requiredFields.includes("occurrenceType") &&
              !props.occurrence?.occurrenceType
              ? "has-error"
              : ""
              }`}
          >
            <label htmlFor="occurrenceType" className="truncate">
              {intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.occurrenceType" })}
              {props.requiredFields.includes("occurrenceType") ? " *" : ""}
            </label>
            {props.disabledAllFields ? (
              <div
                id="occurrenceType"
                className="p-3 bg-lighter rounded text-size-14 text-color-black"
              >
                {props.occurrence?.occurrenceType
                  ? (formatOccurrenceTypeLabel(intl, props.occurrence.occurrenceType) ?? props.occurrence.occurrenceType)
                  : "—"}
              </div>
            ) : (
            <Select
              id="occurrenceType"
              className="w-full"
              options={[
                { id: "undefined", label: intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.selectOccurrenceType" }) },
                { id: "P", label: intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.preventive" }) },
                { id: "C", label: intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.corrective" }) },
                { id: "PC", label: intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.preventiveAndCorrective" }) },
                ...(!isDealer ? [{ id: "A", label: intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.roadAssistance" }) }] : []),
                { id: "W", label: intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.towTruck" }) },
                { id: "D", label: intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.vehicleAtDealership" }) },
                { id: "CL", label: intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.claim" }) },
              ]
                .filter((option) => {
                  if (
                    ["P", "PC", "C"].includes(option.id) &&
                    ["P", "PC", "C"].includes(props.occurrence?.occurrenceType ?? "")
                  ) return true;

                  else if (
                    ["A", "W", "D", "CL"].includes(option.id)
                  ) return true;

                  return false;
                })}
              value={[
                (() => {
                  const t = props.occurrence?.occurrenceType;
                  if (!t) return "undefined";
                  if (t === "S" || String(t).toUpperCase() === "CLAIM") return "SINISTRO";
                  return t;
                })()
              ]}
              placeholder={intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.occurrenceType" })}
              onChange={(e) => {
                if (e && e.id !== "undefined") {
                  const occurrenceType = e.id === "SINISTRO" ? "S" : e.id;
                  props.occurrence &&
                    props.setOccurrenceValue("occurrenceType", occurrenceType);
                } else {
                  props.occurrence && props.setOccurrenceValue("occurrenceType", undefined);
                }

                // Reset volks essentials plan revision sku
                props.occurrence && props.setOccurrenceValue("volksEssentialsPlanRevisionSku", undefined);
                props.occurrence && props.setOccurrenceValue("volksEssentialsPlanContract", undefined);
              }}
              disabled={
                ["P", "PC", "C"].includes(props.occurrence?.occurrenceType ?? "") ||
                props.disabledFields.includes("occurrenceType")
              }
            />
            )}
          </div>
        )}

        {!props.hiddenFields.includes("vehicleChassis") && (
          <div
            className={`form-group form-group-lg w-full ${props.hasError &&
              props.requiredFields.includes("vehicleChassis") &&
              !props.occurrence?.vehicleChassis
              ? "has-error"
              : ""
              }`}

          >
            <label htmlFor="vehicleChassis" className="truncate">
              {intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.chassisLabel" })}
              {props.requiredFields.includes("vehicleChassis") ? " *" : ""}
            </label>
            <div className={`flex gap-4 ${isMobile() ? "flex-wrap" : "items-center"}`}>
              <div className="relative flex-1">
                <input
                  id="vehicleChassis"
                  type="text"
                  className="form-control pr-10"
                  placeholder={intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.chassisPlaceholder" })}
                  disabled={props.disabledAllFields || props.disabledFields.includes("vehicleChassis")}
                  value={props.occurrence?.vehicleChassis}
                  onChange={(e) => {
                    const chassis = e.target.value;

                    props.occurrence &&
                      props.setOccurrenceValue("vehicleChassis", chassis);

                    // Validate chassis and fetch asset details
                    validateChassis(chassis);
                  }}
                  maxLength={17}
                />
                {props.occurrence?.vehicleChassis && (
                  <div className="absolute right-2 top-1/2 transform -translate-y-1/2 margin-right-5">
                    <CopyButton textToCopy={props.occurrence.vehicleChassis} />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      <div className={`flex justify-between w-full gap-6 ${isMobile() ? "flex-wrap" : ""}`}>
        {((
          volksEssentialsPlan && 
            ['P', 'PC', 'D'].includes(props.occurrence?.occurrenceType ?? '')) || props.occurrence?.volksEssentialsPlanContract) &&
              (volksEssentialsPlan?.revision?.length ?? 0) > 0 ? (
          <div
              className={`form-group form-group-lg w-full`}
            >
            <label htmlFor="occurrenceType" className="truncate">
              {intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.type" })}
            </label>
            <Select
              id="occurrenceType"
              className="w-full"
              options={
                volksEssentialsPlan?.revision
                  ?.map((revision, index) => ({
                    id: revision.sku,
                    label: revision.name
                  })) ?? []
              }
              value={[props.occurrence?.volksEssentialsPlanRevisionSku ?? ""]}
              placeholder={intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.revisionType" })}
              onChange={(e) => {
                props.occurrence && ([
                  props.setOccurrenceValue("volksEssentialsPlanRevisionSku", e?.id && e.id !== "-" ? e.id : null),
                  props.setOccurrenceValue("volksEssentialsPlanContract", volksEssentialsPlan?.contract ?? null)
                ])
              }}
              disabled={props.disabledAllFields || props.disabledFields.includes("volksEssentialsPlanContract")}
            />
          </div>
        ) : null}

        {!props.hiddenFields.includes("vehicleCheckup") && props.scheduling && (
          <div className={`form-group form-group-lg w-full`} >
            <label htmlFor="vehicleCheckup" className="truncate">
              {intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.revision" })}
            </label>
            <input
              id="vehicleCheckup"
              type="text"
              className="form-control"
              disabled={true}
              value={props.scheduling.checkup?.name}
            />
          </div>
        )}

        {!props.hiddenFields.includes("vehicleModel") && (
          <div
            className={`form-group form-group-lg w-full ${props.hasError &&
              props.requiredFields.includes("vehicleModel") &&
              !props.occurrence?.vehicleModel && !props.occurrence?.model
              ? "has-error"
              : ""
              }`}
          >
            <label htmlFor="vehicleModel" className="truncate">
              {intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.vehicleModel" })}
              {props.requiredFields.includes("vehicleModel") ? " *" : ""}
            </label>
            {(() => {
              const modelFromCode = props.occurrence?.vehicleModelCode
                ? assetModels.find((m) => m.modelCode === props.occurrence?.vehicleModelCode)
                : undefined;

              const modelName = props.occurrence?.model || modelFromCode?.description;

              if (modelName) {
                return (
                  <input
                    id="vehicleModel"
                    type="text"
                    className="form-control"
                    disabled={true}
                    value={modelName}
                  />
                );
              }

              return (
                <SearchAutocomplete
                  id="vehicleModel"
                  placeholder={intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.vehicleModel" })}
                  fetchOptions={async (searchTerm) => assetModels
                    .filter((model) => model.modelId && model.description && model.description.toLowerCase().includes(searchTerm?.toLowerCase()))
                  }
                  optionLabel={{
                    modelCode: intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.code" }),
                    description: intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.model" }),
                  }}
                  optionRenderer={(model: AssetModel) => (
                    <div>
                      <strong>{intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.codeColon" })}</strong> {model.modelCode} - <strong>{intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.modelColon" })}</strong> {model.description ?? "-"}
                    </div>
                  )}
                  onSelectedOption={(model: AssetModel) => {
                    props.occurrence &&
                      props.setOccurrenceValue("vehicleModel", model.modelId);
                    props.setOccurrenceValue("model", model.description);
                    props.setOccurrenceValue("vehicleModelCode", model.modelCode);
                  }}
                  overlay
                  overlayClassName="!w-[44%]"
                  defaultValue={props.occurrence?.vehicleModel && assetModels.length > 0 ? assetModels.find((model) => model.modelId === props.occurrence?.vehicleModel) : undefined}
                  disabled={props.disabledAllFields || props.disabledFields.includes("vehicleModel")}
                />
              );
            })()}
          </div>
        )}
      </div>

      <div
        className={`flex justify-between w-full gap-6 ${isMobile() ? "flex-wrap" : ""
          }`}
      >
        {!props.hiddenFields.includes("vehicleLicensePlate") && (
          <div
            className={`form-group form-group-lg w-full ${props.hasError &&
              props.requiredFields.includes("vehicleLicensePlate") &&
              !props.occurrence?.vehicleLicensePlate
              ? "has-error"
              : ""
              }`}
          >
            <label htmlFor="vehicleLicensePlate" className="truncate">
              {intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.licensePlate" })}
              {props.requiredFields.includes("vehicleLicensePlate") ? " *" : ""}
            </label>
            <div className="relative">
              <input
                id="vehicleLicensePlate"
                type="text"
                className="form-control pr-10"
                placeholder={intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.licensePlate" })}
                disabled={
                  props.disabledAllFields ||
                  props.disabledFields.includes("vehicleLicensePlate")
                }
                value={props.occurrence?.vehicleLicensePlate ?? ""}
                onChange={(e) =>
                  props.occurrence &&
                  props.setOccurrenceValue("vehicleLicensePlate", e.target.value)
                }
                maxLength={7}
              />
              {props.occurrence?.vehicleLicensePlate && (
                <div className="absolute right-2 top-1/2 transform -translate-y-1/2 margin-right-5">
                  <CopyButton textToCopy={props.occurrence.vehicleLicensePlate} />
                </div>
              )}
            </div>
          </div>
        )}

        {!props.hiddenFields.includes("vehicleType") && (
          <div
            className={`form-group form-group-lg w-full ${props.hasError &&
              props.requiredFields.includes("vehicleType") &&
              !props.occurrence?.vehicleType
              ? "has-error"
              : ""
              }`}
          >
            <label htmlFor="vehicleType" className="truncate">
              {intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.vehicleType" })}
              {props.requiredFields.includes("vehicleType") ? " *" : ""}
            </label>
            <Select
              id="vehicleType"
              options={[
                { label: intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.truck" }), id: "truck" },
                { label: intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.bus" }), id: "bus" },
                { label: intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.van" }), id: "van" },
                { label: intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.trailer" }), id: "trailer" },
                { label: intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.car" }), id: "car" },
              ]}
              disabled={
                props.disabledAllFields ||
                props.disabledFields.includes("vehicleType")
              }
              placeholder={intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.vehicleType" })}
              className="w-full"
              value={
                props.occurrence?.vehicleType
                  ? [props.occurrence?.vehicleType]
                  : undefined
              }
              onChange={(e) =>
                props.occurrence &&
                props.setOccurrenceValue("vehicleType", e?.id ?? null)
              }
            />
          </div>
        )}

        {!props.hiddenFields.includes("vehicleName") && (
          <div
            className={`form-group form-group-lg w-full ${props.hasError &&
              props.requiredFields.includes("vehicleName") &&
              !props.occurrence?.vehicleName
              ? "has-error"
              : ""
              }`}
          >
            <label htmlFor="vehicleName" className="truncate">
              {intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.vehicleName" })}
              {props.requiredFields.includes("vehicleName") ? " *" : ""}
            </label>
            <div className="relative">
              <input
                id="vehicleName"
                type="text"
                className="form-control pr-10"
                placeholder={intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.vehicleName" })}
                disabled={true}
                value={props.occurrence?.vehicleName}
                onChange={(e) =>
                  props.occurrence &&
                  props.setOccurrenceValue("vehicleName", e.target.value)
                }
                maxLength={100}
              />
              {props.occurrence?.vehicleName && (
                <div className="absolute right-2 top-1/2 transform -translate-y-1/2 margin-right-5">
                  <CopyButton textToCopy={props.occurrence.vehicleName} />
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      <div
        className={`flex justify-between w-full gap-6 ${isMobile() ? "flex-wrap" : ""
          }`}
      >
        {!props.hiddenFields.includes("vehicleYear") && (
          <div
            className={`form-group form-group-lg w-full ${props.hasError &&
              props.requiredFields.includes("vehicleYear") &&
              !props.occurrence?.vehicleYear
              ? "has-error"
              : ""
              }`}
          >
            <label htmlFor="vehicleYear" className="truncate">
              {intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.year" })}{props.requiredFields.includes("vehicleYear") ? " *" : ""}
            </label>
            <input
              id="vehicleYear"
              type="text"
              className="form-control"
              placeholder={intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.year" })}
              disabled={
                props.disabledAllFields ||
                props.disabledFields.includes("vehicleYear")
              }
              value={props.occurrence?.vehicleYear}
              onChange={(e) => {
                const value = e.target.value || "0";
                if (value === "" || /^[0-9]*$/.test(value)) {
                  props.occurrence &&
                    props.setOccurrenceValue("vehicleYear", parseInt(value));
                }
              }}
              maxLength={4}
            />
          </div>
        )}

        {!props.hiddenFields.includes("vehicleSaleDate") && (
          <div
            className={`form-group form-group-lg w-full ${props.hasError &&
              props.requiredFields.includes("vehicleSaleDate") &&
              !props.occurrence?.vehicleSaleDate
              ? "has-error"
              : ""
              }`}
          >
            <label htmlFor="vehicleSaleDate" className="truncate">
              {intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.saleDate" })}
              {props.requiredFields.includes("vehicleSaleDate") ? " *" : ""}
            </label>
            {props.disabledAllFields ||
              props.disabledFields.includes("vehicleSaleDate") ? (
              <input
                id="vehicleSaleDate"
                type="text"
                className="form-control"
                placeholder={intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.saleDate" })}
                disabled={true}
                value={
                  props.occurrence?.vehicleSaleDate
                    ? new Date(
                      props.occurrence?.vehicleSaleDate
                    ).toLocaleDateString(intl.locale)
                    : ""
                }
              />
            ) : (
              <DatePicker
                id="vehicleSaleDate"
                className="pb-0 mb-0"
                value={props.occurrence?.vehicleSaleDate}
                onChange={(result: Moment | string) =>
                  props.occurrence &&
                  props.setOccurrenceValue(
                    "vehicleSaleDate",
                    new Date(result as string)
                  )
                }
                dateFormat="DD-MM-YYYY"
                timeFormat={false}
                locale={intl.locale}
              />
            )}
          </div>
        )}

        {!props.hiddenFields.includes("assetId") && (
          <div className={`form-group form-group-lg w-full`}>
            <label htmlFor="volkstotalContract" className="truncate">
              {intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.volksTotalContract" })}
            </label>
            <div className="relative">
              <input
                id="volkstotalContract"
                type="text"
                className="form-control pr-10 text-color-primary font-bold"
                placeholder={intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.volksTotalContract" })}
                disabled={true}
                value={volkstotalData ? 
                  `${volkstotalData.contractNumber} - ${volkstotalData.modality}` 
                  : volksEssentialsPlan
                    ? 'Volks|Total Essencial' 
                    : ''}
              />
              {volkstotalData && (
                <div className="absolute right-2 top-1/2 transform -translate-y-1/2">
                  <CopyButton textToCopy={`${volkstotalData.contractNumber} - ${volkstotalData.modality}`} />
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      <div
        className={`flex justify-between w-full gap-6 ${isMobile() ? "flex-wrap" : ""
          }`}
      >
        {!props.hiddenFields.includes("vehicleOdometer") && (
          <div
            className={`form-group form-group-lg w-full ${props.hasError &&
              props.requiredFields.includes("vehicleOdometer") &&
              !props.occurrence?.vehicleOdometer
              ? "has-error"
              : ""
              }`}
          >
            <label htmlFor="vehicleOdometer" className="truncate">
              {intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.odometer" })}
              {props.requiredFields.includes("vehicleOdometer") ? " *" : ""}
            </label>
            <input
              id="vehicleOdometer"
              type="text"
              className="form-control"
              placeholder={intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.odometer" })}
              disabled={
                props.disabledAllFields ||
                props.disabledFields.includes("vehicleOdometer")
              }
              value={props.occurrence?.vehicleOdometer}
              onChange={(e) => {
                const value = e.target.value || "0";
                if (value === "" || /^[0-9]*$/.test(value)) {
                  props.occurrence &&
                    props.setOccurrenceValue(
                      "vehicleOdometer",
                      parseInt(value)
                    );
                }
              }}
              maxLength={6}
            />
          </div>
        )}

        {!props.hiddenFields.includes("vehicleHourmeter") && (
          <div
            className={`form-group form-group-lg w-full ${props.hasError &&
              props.requiredFields.includes("vehicleHourmeter") &&
              !props.occurrence?.vehicleHourmeter
              ? "has-error"
              : ""
              }`}
          >
            <label htmlFor="vehicleHourmeter" className="truncate">
              {intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.hourmeter" })}
              {props.requiredFields.includes("vehicleHourmeter") ? " *" : ""}
            </label>
            <input
              id="vehicleHourmeter"
              type="text"
              className="form-control"
              placeholder={intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.hourmeter" })}
              disabled={
                props.disabledAllFields ||
                props.disabledFields.includes("vehicleHourmeter")
              }
              value={props.occurrence?.vehicleHourmeter}
              onChange={(e) => {
                const value = e.target.value || "0";
                if (value === "" || /^[0-9]*$/.test(value)) {
                  props.occurrence &&
                    props.setOccurrenceValue(
                      "vehicleHourmeter",
                      parseInt(value)
                    );
                }
              }}
              maxLength={6}
            />
          </div>
        )}
      </div>



      <div
        className={`flex justify-between w-full gap-6 ${isMobile() ? "flex-wrap" : ""
          }`}
      >
        {!props.hiddenFields.includes("customer") && (
          <div
            className={`form-group form-group-lg w-full ${props.hasError &&
              props.requiredFields.includes("customer") &&
              !props.occurrence?.customer
              ? "has-error"
              : ""
              }`}
          >
            <label htmlFor="customer" className="truncate">
              {intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.customerName" })}
              {props.requiredFields.includes("customer") ? " *" : ""}
            </label>
            <input
              id="customer"
              type="text"
              className="form-control"
              placeholder={intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.customerName" })}
              disabled={true}
              value={
                props.occurrence?.customer || props.occurrence?.accountName
              }
              onChange={(e) =>
                props.occurrence &&
                props.setOccurrenceValue("customer", e.target.value)
              }
              maxLength={100}
            />
          </div>
        )}

        {!props.hiddenFields.includes("emissionStandard") && (
          <div
            className={`form-group form-group-lg w-full ${props.hasError &&
              props.requiredFields.includes("emissionStandard") &&
              !props.occurrence?.emissionStandard
              ? "has-error"
              : ""
              }`}
          >
            <label htmlFor="emissionStandard" className="truncate">
              {intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.legislation" })}
              {props.requiredFields.includes("emissionStandard") ? " *" : ""}
            </label>
            <Select
              id="emissionStandard"
              className="w-full"
              disabled={
                props.disabledAllFields ||
                props.disabledFields.includes("emissionStandard")
              }
              placeholder={intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.legislation" })}
              value={props.occurrence?.emissionStandard ? [props.occurrence?.emissionStandard] : undefined}
              onChange={(e) =>
                props.occurrence &&
                props.setOccurrenceValue("emissionStandard", e?.id ?? null)
              }
              options={[
                { id: "EURO 3", label: "EURO 3" },
                { id: "EURO 5", label: "EURO 5" },
                { id: "EURO 6", label: "EURO 6" },
                { id: "ELETRICO", label: intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.electric" }) }
              ]}
            />

          </div>
        )}
      </div>

      <ErrorDialog
        show={showErrorDialog}
        title={errorMessage?.title ?? intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.error" })}
        body={errorMessage?.body ?? ""}
        onClose={() => setShowErrorDialog(false)}
      />

      <LoadingDialog
        show={showLoadingDialog}
        title={loadingMessage?.title ?? intl.formatMessage({ id: "intl-msg:kanban.form.vehicleChildForm.loading" })}
        body={loadingMessage?.body ?? ""}
      />
    </>
  );
};

export default VehicleChildForm;
